export default "/images/vendor/flag-icon-css/flags/1x1/kn.svg?091a5508172f8eee28f23ce17d744ecb";